import React from 'react'

/**
 * Standard page header: bold title on the left, optional subtitle under it,
 * optional action slot on the right (typically a <PrimaryButton>).
 *
 * Matches the pattern used on Settings, Team, Notices, and Integrations.
 *
 * Usage:
 *   <PageHeader
 *     title="Widget Settings"
 *     subtitle="Customize how the chat widget appears on your website"
 *     action={<PrimaryButton icon={<SaveIcon />} onClick={save}>Save Changes</PrimaryButton>}
 *   />
 */
export interface PageHeaderProps {
  title: string
  subtitle?: string
  action?: React.ReactNode
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-8">
      <div>
        <h1 className="text-2xl font-bold text-txt-primary">{title}</h1>
        {subtitle && <p className="text-sm text-txt-secondary mt-1">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}
